import { useEffect } from "react";
import { Row, Col, Progress, Modal, message } from "antd";
import useSyncProgressStore from "../../stores/useSyncProgressStore";
import { useHistory } from "react-router-dom";
import { timeStamp } from "../../utils/timestamp";
import db, { isDbBridgeAvailable } from "../../database";
import { v4 as uuidv4 } from "uuid";
import { clock } from "../../utils/clock";
import "./loder.css";
import POSLogo from "../../assets/images/NewLogoCW.svg";
import leftLoading from "../../assets/images/opo.gif";

import "../style.css";
import "../PointOfSale/Restaurant/restaurantStyle.css";
import { getOAuthHeaders } from "../../constants/oAuthValidation";
import { syncProductsUom } from "../../services";
import { syncDocTypes } from "../../services/generic";
import { processSync } from "../Sync/syncData";
import dayjs from "dayjs";
import messages from "../../errors/messages.en-IN.json";
import useAuthStore from "../../stores/useAuthStore";
import { getCurrentTillId } from "../../utils/tillIdentity";
import usePOSConfigStore from "../../stores/usePOSConfigStore";
import useSessionStore from "../../stores/useSessionStore";
import { trace } from "../../utils/debugTrace";
import { getLocalMaxSequence, resolveInitialDocumentSequence } from "../../utils/documentSequenceUtils";
import { logSequenceEvent } from "../../utils/sequenceAudit";

const Login = () => {
  const { percent, promotionPercentage, productPercentage, productCategoryPercentage } = useSyncProgressStore();
  const history = useHistory();
  const tillValue = useAuthStore.getState().tillValue;
  const clock1 = clock();
  const currentDateTime = new Date();
  const nameTill = tillValue?.name;
  let email = "";
  let Enterprise = "";
  const authHeaders = getOAuthHeaders();
  let username;
  let cleanToken;
  if (authHeaders && authHeaders.access_token) {
    email = authHeaders.email;
    Enterprise = authHeaders.Enterprise;
    cleanToken = authHeaders.access_token;
    username = authHeaders.username;
  }

  useEffect(() => {
    (async () => {
      await onLogin(username, cleanToken);
    })();
  }, []);

  const insertTillOpenActivitity = async (tillData) => {
    const tillSession = useSessionStore.getState().tillSession;
    if (tillSession && tillSession.tillStatus === "open") {
      // Verify this session actually exists in DB (not a stale leftover from a previous login)
      try {
        const matchingEvents = await db.tillEvents.where("tillSessionId").equals(tillSession.tillSessionId).toArray();
        const openEvent = matchingEvents?.find((e) => e.tillStatus === "open");
        if (openEvent) {
          history.push("/pos");
          return;
        }
        if (!isDbBridgeAvailable()) {
          // BUG-2081: empty result may mean the Electron IPC bridge is
          // momentarily unreachable, not that the session is actually stale.
          // Trust the existing Zustand session and let PrivateRoute's own
          // bridge-aware re-check be the authority once /pos mounts, instead
          // of clearing a possibly-still-valid session here.
          history.push("/pos");
          return;
        }
      } catch (err) {
        console.error("Error verifying tillSession:", err);
      }
      // Stale session (no matching DB record) — clear it and proceed with fresh open
      console.warn("Clearing stale tillSession in Login — no matching tillEvent found");
      useSessionStore.getState().setTillSession(null);
    }
    if (!tillSession || !useSessionStore.getState().tillSession) {
      db.tillRegistrations.toArray().then((reg) => {
        if (reg.length > 0) {
          const curList = reg[0].tillAccess[0].csBunit.csCurrency;
          const csCurrencyId = curList.csCurrencyId;
          localStorage.setItem("csCurrencyId", csCurrencyId);
        }
      });
      const tillSessionId = uuidv4().replace(/-/g, "").toUpperCase();
      const userData = useAuthStore.getState().userData;
      const user = userData?.user || "";
      const openTillData = {
        tillSessionId: tillSessionId,
        tillStatus: "open",
        isSynced: 0,
        openingTime: timeStamp(),
        // Business date this session is booked under (same stamp as OpenTill/index.js:222) —
        // required so post-midnight orders under this session stay on the opening date
        // instead of order-time consumers falling back to the live clock.
        businessDate: useSessionStore.getState().nextBusinessDate
          ? dayjs(useSessionStore.getState().nextBusinessDate).format("YYYY-MM-DD")
          : dayjs(new Date()).format("YYYY-MM-DD"),
        closingTime: null,
        openingCashDenominations: [
          { denomination: 1, count: 0, amount: 0 },
          { denomination: 2, count: 0, amount: 0 },
          { denomination: 5, count: 0, amount: 0 },
          { denomination: 10, count: 0, amount: 0 },
          { denomination: 20, count: 0, amount: 0 },
          { denomination: 50, count: 0, amount: 0 },
          { denomination: 100, count: 0, amount: 0 },
          { denomination: 200, count: 0, amount: 0 },
          { denomination: 500, count: 0, amount: 0 },
          { denomination: 2000, count: 0, amount: 0 },
        ],
        closingCashDenominations: null,
        openingCash: 0,
        closingCash: null,
        totalOpeningAmount: 0,
        totalClosingExpectedAmount: null,
        totalClosingTransactions: null,
        totalClosingAmount: null,
        user: user,
      };
      try {
        await db.tillEvents.add({ ...openTillData });
        const ordersData = {
          tillSessionId: tillSessionId,
          tillStatus: "open",
          date: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          netTotal: 0,
          grossTotal: 0,
          totalTax: 0,
          items: [],
          netReturnTotal: 0,
          grossReturnTotal: 0,
          totaReturnlTax: 0,
          salesTransactions: 0,
          returnsTransactions: 0,
          salesTax: [],
          returnTax: [],
        };
        const paymentsData = {
          tillSessionId: tillSessionId,
          tillStatus: "open",
          date: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          payments: tillData?.tillAccess?.csBunit?.paymentMethodList || [],
        };
        await db.ordersData.add({ ...ordersData });
        await db.paymentsData.add({ ...paymentsData });
        useSessionStore.getState().setTillSession(openTillData);
        // A brand-new till session (fresh tillSessionId, just opened) is the one
        // unambiguous signal that any prior Day End Application lock (see
        // cashToKeep.js) is behind us.
        useSessionStore.getState().setDayEndAppUrl(null);
        history.push("/pos");
      } catch (dbErr) {
        console.error("[Login] Failed to write till event to DB:", dbErr);
        message.error("Failed to initialize till session. Please try again.");
        history.push("/till");
      }
    }
  };

  const onLogin = async () => {
    if (!username) {
      return;
    }

    // Ensure userData is available — may be missing after overnight idle
    // (logout clears it, and Till.js SSO bootstrap may have failed)
    let userData = useAuthStore.getState().userData;
    // Also re-fetch when cached userData belongs to a different user than the one
    // currently authenticated via cookies (stale cache from a prior user on this
    // browser/device) — otherwise the wrong user_id propagates downstream.
    // NOTE: the User object's display-name field is "user", not "username".
    const identityMismatch = username && userData?.user && userData.user !== username;
    if (!userData?.user_id || identityMismatch) {
      try {
        const { getGlobalParameters } = await import("../../services/generic");
        const gpRes = await getGlobalParameters();
        if (gpRes?.status === 200) {
          const parsed = JSON.parse(gpRes.data.data.getGlobalParameters);
          useAuthStore.getState().setUserData(parsed.User);
          userData = parsed.User;
        }
      } catch (err) {
        console.error("[Login] Failed to fetch userData:", err);
      }
    }

    const posType = usePOSConfigStore.getState().posType;
    const posConfig = usePOSConfigStore.getState().posConfig;
    let tillData = useAuthStore.getState().tillData;
    trace("Login", "onLogin start", {
      posType,
      hasTillData: !!tillData,
      tillAccessIsArray: Array.isArray(tillData?.tillAccess),
      hasCsBunit: !!tillData?.tillAccess?.csBunit,
      showTillOpening: posConfig?.showTillOpening,
    });
    if (!tillData) {
      trace("Login", "no tillData → /till");
      history.push("/till");
      return;
    }
    if (!tillData.tillAccess) {
      trace("Login", "no tillAccess → /till");
      message.error("Till access configuration is missing. Redirecting to till selection.");
      history.push("/till");
      return;
    }

    const tillAccessIndex = Array.isArray(tillData?.tillAccess) ? tillData.tillAccess.findIndex((accessTill) => accessTill.cwrTill.till === nameTill) : -1;

    if (tillAccessIndex !== -1) {
      tillData.tillAccess = tillData.tillAccess[tillAccessIndex];
    }

    // Sort paymentMethodList by sequenceNo and ensure it's saved
    if (tillData.tillAccess?.csBunit?.paymentMethodList) {
      tillData.tillAccess.csBunit.paymentMethodList = [...tillData.tillAccess.csBunit.paymentMethodList].sort((a, b) => {
        if (a.sequenceNo === null && b.sequenceNo === null) return 0;
        if (a.sequenceNo === null) return 1;
        if (b.sequenceNo === null) return -1;
        return a.sequenceNo - b.sequenceNo;
      });
    }

    // Update tillData with current time and save to localStorage + Zustand
    tillData.time = dayjs().format("YYYY-MM-DD HH:mm:ss");
    useAuthStore.getState().setTillData(tillData);
    localStorage.setItem("username", username);
    useAuthStore.getState().setUsername(username);
    const cwrTill = tillData.tillAccess.cwrTill;
    const serverRegularSeq = cwrTill.nextAssignedNumber || 0;
    const localRegularMax = await getLocalMaxSequence(db, cwrTill.prefix);
    const prevRegularCounter = useSessionStore.getState().documentSequence;
    const chosenRegularSeq = resolveInitialDocumentSequence(serverRegularSeq, localRegularMax);
    useSessionStore.getState().setDocumentSequence(chosenRegularSeq);
    logSequenceEvent(
      "init",
      { source: "login", prefix: cwrTill.prefix, serverSeq: serverRegularSeq, localMax: localRegularMax, chosen: chosenRegularSeq, prevCounter: prevRegularCounter },
      db
    );

    const preorderSeq = cwrTill.preorderSequence ? { ...cwrTill.preorderSequence } : null;
    if (preorderSeq) {
      const localPreorderMax = await getLocalMaxSequence(db, preorderSeq.prefix);
      preorderSeq.nextNo = Math.max(preorderSeq.nextNo || 0, localPreorderMax);
    }
    useSessionStore.getState().setPreorderSequence(preorderSeq);
    // TIC/BUG advance-seq-race diagnostic (temporary): this is the daily-login path
    // (runs every shift start, unlike Till.js's one-time registration) — the most
    // likely place to correlate against an order that got the wrong sequence shortly
    // after. Every WRITE to preorderSequence is logged so a later backup export can
    // line up "when was it set/cleared" against "what did the failing order read".
    logSequenceEvent("preorder-seq-write", { source: "login", value: preorderSeq, till: cwrTill.prefix }, db);

    const cancelledSeq = cwrTill.cancelledOrderSequence ? { ...cwrTill.cancelledOrderSequence } : null;
    if (cancelledSeq) {
      const localCancelledMax = await getLocalMaxSequence(db, cancelledSeq.prefix);
      cancelledSeq.nextNo = Math.max(cancelledSeq.nextNo || 0, localCancelledMax);
    }
    useSessionStore.getState().setCancelledOrderSequence(cancelledSeq);

    const seqPrefixes = [cwrTill.prefix, preorderSeq?.prefix, cancelledSeq?.prefix].filter(Boolean);
    if (new Set(seqPrefixes).size !== seqPrefixes.length) {
      console.error("[SEQ] Duplicate prefixes detected — falling back to single sequence mode");
      useSessionStore.getState().setPreorderSequence(null);
      useSessionStore.getState().setCancelledOrderSequence(null);
      logSequenceEvent(
        "preorder-seq-write",
        { source: "login-duplicate-prefix-fallback", value: null, till: cwrTill.prefix, seqPrefixes },
        db
      );
    }

    localStorage.setItem("estimateNo", 1);
    localStorage.setItem("kioskUI", 0);

    const usernameData = localStorage.getItem("username") || "";
    const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
    const matchedRep = salesReps.find((rep) => rep?.name === usernameData);

    if (posType === "PRD") {
      if (posConfig?.enableProduction === "Y") {
        await syncProductsUom(uuidv4().replace(/-/g, "").toUpperCase(), getCurrentTillId());
        await syncDocTypes();
        history.push("/production");
      } else if (posConfig?.enableProductionRMIssue === "Y") {
        await syncProductsUom(uuidv4().replace(/-/g, "").toUpperCase(), getCurrentTillId());
        await syncDocTypes();
        history.push("/production-rm-issue");
      } else {
        message.error(`${messages.errors.till_management.production_not_enabled}`);
      }
    } else {
      // Always sync on login — processSync decides Full vs Incremental itself
      // based on lastUpdatedTime, so a previously-synced till gets a fast
      // incremental catch-up instead of either a forced full resync or (the
      // pre-BUG-1457 bug) no sync at all.
      try {
        await processSync(tillData);
      } catch (syncError) {
        console.error("[Login] processSync failed:", syncError);
        message.error("Sync failed. Please try again.");
        history.push("/till");
        return;
      }

      if (posConfig?.enableEstimate === "Y") {
        trace("Login", "→ /estimate");
        history.push("/estimate");
      } else {
        if (posConfig?.showTillOpening === "Y") {
          trace("Login", "showTillOpening=Y", { matchedRep: !!matchedRep });
          if (matchedRep) {
            const tillSessionId = uuidv4().replace(/-/g, "").toUpperCase();
            const tillData = useAuthStore.getState().tillData;
            const userData = useAuthStore.getState().userData;
            const user = userData?.user || "";
            const openTillData = {
              tillSessionId: tillSessionId,
              tillStatus: "open",
              isSynced: 0,
              openingTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
              // Business date this session is booked under (same stamp as OpenTill/index.js:222) —
              // required so post-midnight orders under this session stay on the opening date
              // instead of order-time consumers falling back to the live clock.
              businessDate: useSessionStore.getState().nextBusinessDate
                ? dayjs(useSessionStore.getState().nextBusinessDate).format("YYYY-MM-DD")
                : dayjs(new Date()).format("YYYY-MM-DD"),
              closingTime: null,
              openingCashDenominations: [],
              closingCashDenominations: null,
              openingCash: 0,
              closingCash: 0,
              totalOpeningAmount: 0,
              totalClosingExpectedAmount: 0,
              totalClosingTransactions: 0,
              totalClosingAmount: 0,
              user: user,
            };

            const ordersData = {
              tillSessionId: tillSessionId,
              tillStatus: "open",
              date: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
              netTotal: 0,
              grossTotal: 0,
              totalTax: 0,
              items: [],
              netReturnTotal: 0,
              grossReturnTotal: 0,
              totaReturnlTax: 0,
              salesTransactions: 0,
              returnsTransactions: 0,
              salesTax: [],
              returnTax: [],
            };

            const paymentsData = {
              tillSessionId: tillSessionId,
              tillStatus: "open",
              date: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
              payments: tillData?.tillAccess?.csBunit?.paymentMethodList || [],
            };
            try {
              await db.tillEvents.add({ ...openTillData });
              await db.ordersData.add({ ...ordersData });
              await db.paymentsData.add({ ...paymentsData });
              useSessionStore.getState().setTillSession(openTillData);
              // A brand-new till session (fresh tillSessionId, just opened) is the one
              // unambiguous signal that any prior Day End Application lock (see
              // cashToKeep.js) is behind us.
              useSessionStore.getState().setDayEndAppUrl(null);
              trace("Login", "matchedRep: session + DB written → /pos");
              history.push("/pos");
            } catch (dbErr) {
              console.error("[Login] matchedRep: Failed to write till event to DB:", dbErr);
              message.error("Failed to initialize till session. Please try again.");
              history.push("/till");
            }
          } else {
            const existingEvents = await db.tillEvents.toArray();
            const openEvent = existingEvents?.find((e) => e.tillStatus === "open");
            if (openEvent) {
              trace("Login", "no matchedRep but open tillEvent found in DB → /pos");
              useSessionStore.getState().setTillSession(openEvent);
              history.push("/pos");
            } else {
              const redirectUrl = posConfig?.showDenominations === "Y" ? "/open-till" : "/open-till-component";
              trace("Login", "no matchedRep → " + redirectUrl);
              history.push(redirectUrl);
            }
          }
        } else {
          trace("Login", "showTillOpening !== Y → insertTillOpenActivitity");
          await insertTillOpenActivitity(tillData);
        }
      }
    }
  };

  const formattedDateTime = currentDateTime.toLocaleDateString("en-US", {
    day: "2-digit", // Two-digit day of the month
    month: "2-digit", // Two-digit month
    year: "numeric", // Full year (e.g., 2023)
  });

  return (
    <div className="sync-loading-root" style={{ backgroundColor: "#F3F4F9", height: "100vh", width: "100%" }}>
      <Row className="sync-loading-header" style={{ height: "9vh", background: "", padding: "0.8% 0" }}>
        <Col span={6}>
          <img
            src={POSLogo}
            className="sync-loading-logo"
            onClick={() => history.push("/")}
            style={{ height: "2.8vw", paddingLeft: "1vw", paddingTop: "1vh", cursor: "pointer" }}
          />
        </Col>
        <Col span={18} className="sync-loading-datetime" style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", paddingRight: "1vw", fontSize: "1vw" }}>
          <div style={{ fontWeight: 400, fontFamily: "Inter", fontSize: "1.2em", color: "#0F0718" }}>{formattedDateTime}</div>
          <div style={{ fontWeight: 400, fontFamily: "Inter", fontSize: "1.2em", color: "#0F0718" }}>{clock1}</div>
        </Col>
      </Row>
      <div className="sync-loading-panels" style={{ display: "flex", height: "90vh" }}>
        <div
          className="sync-loading-left-panel"
          style={{
            width: "48%",
            background: "#fff",
            height: "83vh",
            margin: "1.5%",
            marginRight: 0,
            borderRadius: "10px",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <div className="sync-loading-left-content" style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "1vw" }}>
            <div className="sync-loading-gif-wrap" style={{ position: "relative", width: "13vw", height: "13vw" }}>
              <img
                src={leftLoading}
                alt="Loading"
                style={{
                  width: "100%",
                  height: "100%",
                  // transform: `rotate(${rotation}deg)`,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  fontSize: "1.5em",
                  fontWeight: "500",
                  color: "#0F0718",
                }}
              >
                {percent}
              </div>
            </div>
            <p style={{ color: "#0F0718", fontFamily: "Inter", fontWeight: 500, fontSize: "2.5em", marginBottom: 0 }}>Till loading in process</p>
            {/* <p style={{color:"#D73A48",fontFamily:"Inter",fontWeight:500,fontSize:"1.5vw",marginBottom:0}}>{formatTime(time)}</p>
            <p style={{color:"#0F0718",fontFamily:"Inter",fontWeight:500,fontSize:"1.5vw"}}>Minutes Left</p> */}
          </div>
        </div>
        <div className="sync-loading-right-panel" style={{ width: "48%", height: "83vh", background: "#fff", margin: "1.5%", borderRadius: "10px" }}>
          <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "17vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>Product Categories</p>
          <Progress
            strokeColor={{
              from: "#2F3856",
              to: "#2F3856",
            }}
            // showInfo={false}
            style={{ padding: "0 2.5vw" }}
            percent={productCategoryPercentage}
            status="active"
          />
          <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "7vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>Products</p>
          <Progress
            strokeColor={{
              from: "#2F3856",
              to: "#2F3856",
            }}
            // showInfo={false}
            style={{ padding: "0 2.5vw" }}
            percent={productPercentage}
            status="active"
          />
          <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "7vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>Promotions</p>
          <Progress
            strokeColor={{
              from: "#2F3856",
              to: "#2F3856",
            }}
            // showInfo={false}
            style={{ padding: "0 2.5vw" }}
            percent={promotionPercentage}
            status="active"
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
